import 'core-js/stable'
import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'

import { configureStore } from './store'
import { defaultAnonymousContext } from './helpers/ldHelpers'

import './index.css'
import 'antd/dist/antd.css'
import App from './App'

import unregister from './registerServiceWorker'

const appContainer = document.getElementById('root')
const store = configureStore()

// Initialize the LaunchDarkly client and wait for it to load flags BEFORE the
// first render, so feature flags (e.g. stripePaymentElementBorrower) are
// available on the very first paint. The previous withLDProvider HOC rendered
// immediately, so the borrower Payment step evaluated the flag as false before
// flags loaded and fell back to the legacy VGS form. `timeout` bounds how long
// the first render waits on LD (matches the lender-frontend setup); on timeout
// LD resolves with whatever loaded, so the app never hangs.
;(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.LD_CLIENT_ID,
    context: defaultAnonymousContext,
    timeout: 3,
  })

  ReactDOM.render(
    <LDProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </LDProvider>,
    appContainer
  )
  unregister()
})()
